const AM_RATING_TRIGGER = 'data-rating'
const AM_RATING_NOTE = 'data-rating-note'
const AM_RATING_INPUT = 'data-rating-input'

window.amRating = class amRating {
  static note ($element, note) {
    // find parent container
    const $container = $element.closest(`[${AM_RATING_TRIGGER}]`)
    // find other notes
    const $ratings = $container.querySelectorAll(`[${AM_RATING_NOTE}]`)
    // find input container
    const $inputContainer = $container.querySelector(`[${AM_RATING_INPUT}]`)
    // find input
    const $input = $inputContainer.querySelector('input[type=number]')
    // update input
    $input.value = note;
    // reset notes status
    $ratings.forEach($rating => {
      const ratingNote = $rating.getAttribute(AM_RATING_NOTE)
      if (ratingNote <= note) {
        $rating.classList.add('active')
      } else {
        $rating.classList.remove('active')
      }
    })
    // update other notes
  }
}

function init(){

}

export default { init }
